<template>
  <div>
    <Head></Head>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item class="dqwz">当前位置：</el-breadcrumb-item>

      <el-breadcrumb-item :to="{ path: '/my' }">个人中心</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/my?active=我的报名' }"
        >我的报名</el-breadcrumb-item
      >
      <el-breadcrumb-item class="zpgg">报名表打印</el-breadcrumb-item>
    </el-breadcrumb>
    <el-row class="tac">
      <!-- 公共内容 -->
      <Process></Process>
      <!-- 右边内容 -->
      <el-col :span="18" class="conter">
        <div id="printTest">
          <table align="center" border="2px" cellspacing="0" cellpadding="2">
            <caption>
              报名人员信息表
            </caption>

            <tr>
              <td width="10%">姓名</td>
              <td width="15%">{{ list.real_name }}</td>
              <td width="10%">性别</td>
              <td width="10%">{{ list.sex == 1 ? "男" : "女" }}</td>
              <td width="10%">民族</td>
              <td width="10%">{{ list.nation ? list.nation.name : "" }}</td>
              <td width="10%">出生年月</td>
              <td width="10%">{{ list.birth_date }}</td>
              <td width="20%" rowspan="4" align="center">
                <img :src="list.id_photo" alt="" style="width: 90%" />
              </td>
            </tr>
            <tr>
              <td width="10%">籍贯</td>
              <td width="10%">{{ list.native_place }}</td>
              <td width="10%">婚姻情况</td>
              <td width="10%">{{ list.marriage == 1 ? "已婚" : "未婚" }}</td>
              <td width="10%">最高学历</td>
              <td width="10%">
                {{ list.education ? list.education.name : "" }}
              </td>
              <td width="10%">政治面貌</td>
              <td width="10%">{{ list.face ? list.face.name : "" }}</td>
            </tr>
            <tr>
              <td>期望税前月薪</td>
              <td>{{ list.hope_salary }}</td>
              <td>报名岗位</td>
              <td colspan="2">{{ list.post_name }}</td>
              <td>岗位编号</td>
              <td colspan="2">{{ list.post_code }}</td>
            </tr>
            <tr>
              <td>身份证号码</td>
              <td colspan="3">{{ list.id_card }}</td>
              <td>联系电话</td>
              <td colspan="3">{{ list.mobile }}</td>
            </tr>
            <tr>
              <td>专业技术职称</td>
              <td colspan="3">{{ list.tech_title }}</td>
              <td>通讯地址(可邮寄)</td>
              <td colspan="4">{{ list.mail_address }}</td>
            </tr>
            <tr>
              <td>职(执)业资格证书</td>
              <td colspan="3">{{ list.vocation }}</td>
              <td>现工作单位及地址</td>
              <td colspan="4">{{ list.current_unit }}</td>
            </tr>
            <tr class="td_back">
              <td rowspan="4" align="center">教育经历（高中起）</td>
              <td colspan="2">起止时间</td>
              <td colspan="2">毕业院校</td>
              <td colspan="2">所属专业</td>
              <td colspan="1">学历</td>
              <td colspan="1">全日制/在职</td>
            </tr>
            <tr
              v-if="
                list.user_education_relation && list.user_education_relation[0]
              "
            >
              <td colspan="2">
                {{ list.user_education_relation[0].start_and_end_date }}
              </td>
              <td colspan="2">{{ list.user_education_relation[0].school }}</td>
              <td colspan="2">{{ list.user_education_relation[0].major }}</td>
              <td colspan="1">
                {{ list.user_education_relation[0].education_id }}
              </td>
              <td colspan="1">
                {{ list.user_education_relation[0].school_system }}
              </td>
            </tr>
            <tr v-else>
              <td colspan="2"></td>
              <td colspan="2"></td>
              <td colspan="2"></td>
              <td colspan="1"></td>
              <td colspan="1"></td>
            </tr>

            <tr
              v-if="
                list.user_education_relation && list.user_education_relation[1]
              "
            >
              <td colspan="2">
                {{ list.user_education_relation[1].start_and_end_date }}
              </td>
              <td colspan="2">{{ list.user_education_relation[1].school }}</td>
              <td colspan="2">{{ list.user_education_relation[1].major }}</td>
              <td colspan="1">
                {{ list.user_education_relation[1].education_id }}
              </td>
              <td colspan="1">
                {{ list.user_education_relation[1].school_system }}
              </td>
            </tr>
            <tr v-else>
              <td colspan="2"></td>
              <td colspan="2"></td>
              <td colspan="2"></td>
              <td colspan="1"></td>
              <td colspan="1"></td>
            </tr>
            <tr
              v-if="
                list.user_education_relation && list.user_education_relation[2]
              "
            >
              <td colspan="2">
                {{ list.user_education_relation[2].start_and_end_date }}
              </td>
              <td colspan="2">{{ list.user_education_relation[2].school }}</td>
              <td colspan="2">{{ list.user_education_relation[2].major }}</td>
              <td colspan="1">
                {{ list.user_education_relation[2].education_id }}
              </td>
              <td colspan="1">
                {{ list.user_education_relation[2].school_system }}
              </td>
            </tr>
            <tr v-else>
              <td colspan="2"></td>
              <td colspan="2"></td>
              <td colspan="2"></td>
              <td colspan="1"></td>
              <td colspan="1"></td>
            </tr>
            <tr class="td_back">
              <td rowspan="4" align="center">主要工作经历</td>
              <td colspan="2">起止时间</td>
              <td colspan="2">工作单位</td>
              <td colspan="2">职务</td>
              <td colspan="1">证明人</td>
              <td colspan="1">证明人联系方式</td>
            </tr>

            <tr
              v-if="
                list.user_work_exp_relation && list.user_work_exp_relation[0]
              "
            >
              <td colspan="2">
                {{ list.user_work_exp_relation[0].start_and_end_date }}
              </td>
              <td colspan="2">
                {{ list.user_work_exp_relation[0].work_unit }}
              </td>
              <td colspan="2">{{ list.user_work_exp_relation[0].job }}</td>
              <td colspan="1">{{ list.user_work_exp_relation[0].witness }}</td>
              <td colspan="1">
                {{ list.user_work_exp_relation[0].witness_phone }}
              </td>
            </tr>
            <tr v-else>
              <td colspan="2"></td>
              <td colspan="2"></td>
              <td colspan="2"></td>
              <td colspan="1"></td>
              <td colspan="1"></td>
            </tr>

            <tr
              v-if="
                list.user_work_exp_relation && list.user_work_exp_relation[1]
              "
            >
              <td colspan="2">
                {{ list.user_work_exp_relation[1].start_and_end_date }}
              </td>
              <td colspan="2">
                {{ list.user_work_exp_relation[1].work_unit }}
              </td>
              <td colspan="2">{{ list.user_work_exp_relation[1].job }}</td>
              <td colspan="1">{{ list.user_work_exp_relation[1].witness }}</td>
              <td colspan="1">
                {{ list.user_work_exp_relation[1].witness_phone }}
              </td>
            </tr>
            <tr v-else>
              <td colspan="2"></td>
              <td colspan="2"></td>
              <td colspan="2"></td>
              <td colspan="1"></td>
              <td colspan="1"></td>
            </tr>

            <tr
              v-if="
                list.user_work_exp_relation && list.user_work_exp_relation[2]
              "
            >
              <td colspan="2">
                {{ list.user_work_exp_relation[2].start_and_end_date }}
              </td>
              <td colspan="2">
                {{ list.user_work_exp_relation[2].work_unit }}
              </td>
              <td colspan="2">{{ list.user_work_exp_relation[2].job }}</td>
              <td colspan="1">{{ list.user_work_exp_relation[2].witness }}</td>
              <td colspan="1">
                {{ list.user_work_exp_relation[2].witness_phone }}
              </td>
            </tr>
            <tr v-else>
              <td colspan="2"></td>
              <td colspan="2"></td>
              <td colspan="2"></td>
              <td colspan="1"></td>
              <td colspan="1"></td>
            </tr>

            <tr>
              <td colspan="10">亲属关系情况</td>
            </tr>
            <tr>
              <td colspan="10">
                （若有亲人或朋友现在或曾经任职于报名单位？如有，请详细说明）
              </td>
            </tr>
            <tr>
              <td colspan="1">姓名</td>
              <td colspan="3">单位名称</td>
              <td colspan="2">部门</td>
              <td colspan="2">职务</td>
              <td colspan="1">与本人关系</td>
            </tr>
            <tr
              v-if="list.user_family_relation && list.user_family_relation[0]"
            >
              <td colspan="1">{{ list.user_family_relation[0].full_name }}</td>
              <td colspan="3">{{ list.user_family_relation[0].unit_name }}</td>
              <td colspan="2">{{ list.user_family_relation[0].job }}</td>
              <td colspan="2">{{ list.user_family_relation[0].department }}</td>
              <td colspan="1">
                {{ list.user_family_relation[0].self_relation }}
              </td>
            </tr>
            <tr v-else>
              <td colspan="1"></td>
              <td colspan="3"></td>
              <td colspan="2"></td>
              <td colspan="2"></td>
              <td colspan="1"></td>
            </tr>

            <tr
              v-if="list.user_family_relation && list.user_family_relation[1]"
            >
              <td colspan="1">{{ list.user_family_relation[1].full_name }}</td>
              <td colspan="3">{{ list.user_family_relation[1].unit_name }}</td>
              <td colspan="2">{{ list.user_family_relation[1].job }}</td>
              <td colspan="2">{{ list.user_family_relation[1].department }}</td>
              <td colspan="1">
                {{ list.user_family_relation[1].self_relation }}
              </td>
            </tr>
            <tr v-else>
              <td colspan="1"></td>
              <td colspan="3"></td>
              <td colspan="2"></td>
              <td colspan="2"></td>
              <td colspan="1"></td>
            </tr>

            <tr
              v-if="list.user_family_relation && list.user_family_relation[2]"
            >
              <td colspan="1">{{ list.user_family_relation[2].full_name }}</td>
              <td colspan="3">{{ list.user_family_relation[2].unit_name }}</td>
              <td colspan="2">{{ list.user_family_relation[2].job }}</td>
              <td colspan="2">{{ list.user_family_relation[2].department }}</td>
              <td colspan="1">
                {{ list.user_family_relation[2].self_relation }}
              </td>
            </tr>
            <tr v-else>
              <td colspan="1"></td>
              <td colspan="3"></td>
              <td colspan="2"></td>
              <td colspan="2"></td>
              <td colspan="1"></td>
            </tr>
          </table>
          <p>
            本人承诺，以上所提供的一切信息真实、准确，如有虚假，贵单位有权解除本人可能受聘之职务或采取其他处理方式，本人愿承担一切责任。
          </p>
          <div class="tab_text">
            <span>承诺人（签字）：</span>
            <span>日期：</span>
          </div>
        </div>
      </el-col>
      <div class="re_btm">
        <button v-print="'#printTest'" @click="printNotify(post_id, 102)">
          打印
        </button>
      </div>
    </el-row>

    <Footer></Footer>
  </div>
</template>

<script>
import Head from "./Head";
import Footer from "./Footer";
import Process from "./Process";
export default {
  props: {},
  data() {
    return {
      list: {},
      post_id: 0,
    };
  },
  computed: {},
  created() {},
  mounted() {
    var query = this.$route.query;
    this.post_id = query.post_id;
    this.getInfo(this.post_id, 102);
  },
  watch: {},
  methods: {
    getInfo(id, code) {
      let _this = this;
      _this
        .request("api/post_up_info", { post_id: id, code: code }, "get")
        .then((res) => {
          if (res.data.status == "success") {
            this.list = res.data.data.info;
            //console.log(this.list.user_education_relation)
          }
        });
    },
    //打印后通知服务器
    printNotify(id, code) {
      let _this = this;
      _this
        .request("api/sign_up/print", { post_id: id, code: code }, "post")
        .then(() => {
          _this.$router.push("/step?post_id=" + id);
        });
    },
  },
  components: {
    Head,
    Footer,
    Process,
  },
};
</script>

<style lang="less" scoped>
//.tac {
//  .conter {
table {
  margin: 0 auto;
  border-collapse: collapse;
  width: 21cm;
  caption {
    font-size: 26px;
  }
  tr {
    border-bottom: 2px solid #333;
    th {
    }
    td {
      border: 1px solid #666;
      font-size: 16px;
      text-align: center;
      padding: 10px 0;
      height: 30px;
    }
  }
  .td_back {
    td {
      background-color: #999;
      padding: 10px 0;
      font-weight: 600;
    }
    :nth-of-type(1) {
      background-color: transparent;
    }
  }
}
p {
  width: 21cm;
  padding: 6px 0;
  margin: auto;
}
.tab_text {
  float: right;
  padding: 30px 0;
  padding-right: 71px;

  span {
    font-size: 16px;
    padding-right: 118px;
  }
}

//  }
//}

.re_btm {
  text-align: center;
  padding: 0.8rem 0;
  button {
    width: 3.28rem;
    height: 0.78rem;
    background-color: #00a0e9;
    color: #fff;
    font-size: 0.37rem;
    border-radius: 0.1rem;
  }
}
</style>
